import React from 'react'

import Image from 'components/image'
import Link from 'components/link'
import { withContextualizedTracking } from 'lib/analytics'
import * as blUrls from 'lib/urls'

import * as css from './FooterLandingPage.scss'

const FooterLandingPage = () => (
  <div className={css.container}>
    <div className={css.logoContainer}>
      <Link aria-label="home" url={blUrls.indexPath}>
        <Image
          alt="babylist-logo"
          className={css.logoImage}
          height="38"
          src="//res.cloudinary.com/babylist/image/upload/f_auto,q_auto/v1549314083/Babylist_logo_horizontal_white_qltnll.svg"
          width="170"
        />
      </Link>
    </div>
    <p className={css.watermark}>
      &copy; 2011-{new Date().getFullYear()} Babylist, Inc
    </p>
  </div>
)

export default withContextualizedTracking()(FooterLandingPage)
